import Vue from 'vue'
import Vuex from 'vuex'
import ArrayUtil from 'UTILS/array';

import config from '../config'
import editStore from "./mediaEdit/editStore";
import actions from "./actions";
const { menu,sidebar } = config

Vue.use(Vuex)

let state = Object.assign({},{
  menu,
  sidebar,
  userInfo:{},
  currentFashionMenu: {
    type:0,//市集or发现,0市集,1发现
    moduleType:-1,//不同类型模块
    moduleName:"",//模块名称
    moduleId:0
  }, //【市集/发现】 当前活动菜单
  updateFashionMenu:false,//通知菜单更新的标志量
  updateWaterfall:false, //通知瀑布流进行更新
  articleTotalImgCount:0,//动态页被圈选图片数量
  updateCollapse: false  //通知Collapse更新
},editStore.state);

let mutations = Object.assign({},{
  SET_SIDEBAR(state,val){
    state.sidebar.opened = val;
  },
  SET_MENU_EXPANDED(state,menuIndex,isExpanded) {
    state.menu[menuIndex].expanded = isExpanded;
  },
  SET_USER_INFO(state,userInfo){
    state.userInfo = userInfo;
    let authorization = ArrayUtil.toArray(state.userInfo.authorization);
    let host = window.location.host;
    state.sidebar.opened = true;
  },
  SET_CURRENT_FASHION_MENU(state, menu) {
    state.currentFashionMenu = menu
  },
  COMMIT_FASHION_MENU_UPDATE(state, flag){
    state.updateFashionMenu = flag
    setTimeout(()=>{ //重置
      state.updateFashionMenu = false
    },2000)
  },
  COMMIT_WATERFALL_UPDATE(state, flag){
    state.updateWaterfall = flag
  },
  COMMIT_COLLAPSE_UPDATE(state, flag) {
    state.updateCollapse = flag
  },
  UPDATE_ARTICLE_IMG_COUNT(state, step){
    if(step === 0){
      state.articleTotalImgCount = 0
    }else{
      state.articleTotalImgCount += step
    }
  }
},editStore.mutations);

const store = new Vuex.Store({
  state,
  actions,
  mutations
});

export default store
